<template>
    <div class="article-list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :success-text = "refreshSuccessText" :success-duration = "1000">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="$t('financial.noMore')"

                    @load="onLoad"
            >
                <van-cell v-for="(item,index) in list" :key="index" >
                    <van-row class="list">
                        <van-col span="4" class="list_ico">
                            <van-icon name="star" />
                        </van-col>
                        <van-col span="20" class="list_info">
                            <van-row class="list_flin">
                                <van-col span="16" class="list_title">{{item.type}}</van-col>
                                <van-col span="8" class="list_val">{{item.money}}</van-col>
                            </van-row>
                            <van-row class="list_slin">
                                <van-col span="16" class="list_tiem">{{item.create_time}}</van-col>
                                <van-col span="8" class="list_acount">{{item.after}}</van-col>
                            </van-row>
                        </van-col>
                    </van-row>
                </van-cell>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    export default {
        name: "Flist",
        data(){
            return{
                page : 0,
                page_size: 10,
                page_index : 0,
                list :[],
                loading: false,
                finished: false,
                refreshing: false,
                refreshSuccessText:""
            }
        },
        props :{
            tabindex : {
                type: Number,
                required : true
            }
        },
        mounted(){
            this.page_index = this.tabindex;
        },
        methods:{
            async onLoad() {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                let res =  await this.getFinancial(this.page,this.page_size,this.tabindex);
                if(res.length < this.page_size){
                    this.finished = true;
                }
                //合并数组
              //  this.list= this.list.concat(res);
                this.list.push(...res);

                this.loading = false;
                this.page++;

            },
            getFinancial(page,page_size,type){
                let pages = {'page':page,'page_size':page_size,'type':type};
                return new Promise((resolve, reject) => {
                    this.getReq('/getFinancial', pages).then(
                        (res) => {
                            if (res.code == 200) {
                                resolve(res.data) ;

                            }
                        })
                })
            },

         async onRefresh() {

                let list = await this.getFinancial(this.page,this.page_size,this.tabindex);

                 if(list.length < this.page_size){
                     this.finished = true;
                 }
                this.list.unshift(...list);
                this.refreshSuccessText = this.$t('financial.updatedata',{count : list.length});
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态,false关闭加载
                this.refreshing = false;
                this.page++;

            },
        },

    }
</script>

<style scoped lang="scss">
    .article-list{
        position: fixed;
        left: 16px;
        right: 16px;
        bottom: 50px;
        top: 130px;
        overflow-y: auto;
        .list{
            .list_ico{
                font-size: 20px;
                text-align: center;
                color:#ff9900;
                margin: 0 auto;
            }
            .list_info{
                font-size: 14px;
                color: #666666;
                .list_flin{
                    .list_title{
                        font-weight: bold;
                    }
                    .list_val{
                        color: #f00;
                    }
                }
                .list_slin{
                    color: #cccccc;
                }

            }
        }
    }
</style>
